var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"add-btn p-0 d-flex noglow text-infxo rounded-lgx text-dark shadowx",style:(_vm.btnStyle),attrs:{"variant":"info"},on:{"click":_vm.onAdd}},[_c('icon',{staticClass:"m-auto",attrs:{"name":"mdi.plus-thick"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }